export const GET_MEMBER_SUCCESS = 'GET_MEMBER_SUCCESS'
export const GET_MEMBER_FAILED = 'GET_MEMBER_FAILED'
export const GET_MEMBER_START = 'GET_MEMBER_START'